import axios from "axios";

// ✅ NAS 백엔드 주소를 완전히 고정 (localhost 제거)
const api = axios.create({
  baseURL: "http://192.168.219.127:8888/api",
});

export default api;